import axios from "../axiosPlugin.js";

export const getAccumulatedReportList = data => {
  return axios({
    url: "/api/report/accumulatedReport",
    method: "get",
    data: { data },
  });
};